'use strict';

let routes = function ($stateProvider, baseState) {

    $stateProvider

        .state('' + baseState + '.accounting', {
            abstract: true,
            url: "/accounting?"
            + "cf_ClerkLedgerEntry_page?"
            + "&cf_ClerkLedgerEntry_order?"
            + "&cf_ClerkLedgerEntry_search?"
            + "&cf_ClerkLedgerEntry_ClerkLedgerEntryRow_clerk_ledger_account_id?"
            + "&cf_ClerkLedgerEntry_relevant_clerk_invoice_id?"
            + "&cf_ClerkLedgerEntry_relevant_clerk_travel_claim_id?"
            ,
            params: {
                cf_ClerkLedgerEntry_page: {value: '1', dynamic: true},
                cf_ClerkLedgerEntry_order: {value: null, dynamic: true},
                cf_ClerkLedgerEntry_search: {value: null, dynamic: true},
                cf_ClerkLedgerEntry_ClerkLedgerEntryRow_clerk_ledger_account_id: {value: null, dynamic: true},
                cf_ClerkLedgerEntry_relevant_clerk_invoice_id: {value: null, dynamic: true},
                cf_ClerkLedgerEntry_relevant_clerk_travel_claim_id: {value: null, dynamic: true},
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedgerAccount_columns_by_step = 'attributes';
                },
                setRouteBasedContentFiltersLevel1: /*@ngInject*/ function (routeBasedContentFilters, setRouteBasedContentFiltersLevel0, $stateParams) {
                    if ($stateParams.activeClerkTaxEntityId) {
                        routeBasedContentFilters.ClerkLedgerAccount_clerk_tax_entity_id = $stateParams.activeClerkTaxEntityId;
                    }
                    routeBasedContentFilters.ClerkLedgerAccount_order = 'ClerkLedgerAccount.accounting_reference ASC';
                },
            },
            template: "<ui-view/>",
        });

    require('project/crud/clerk-tax-entity/customized-routes.js').default.routes($stateProvider, '' + baseState + '.accounting');
    require('project/crud/clerk-fiscal-year/customized-routes.js').default.routes($stateProvider, '' + baseState + '.accounting');
    require('project/crud/clerk-ledger/customized-routes.js').default.routes($stateProvider, '' + baseState + '.accounting');

};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.accounting.**', {
        url: "/accounting",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/subsections/inspect-ledger-contents/inspect-ledger-contents.routing.js